module.exports = __webpack_public_path__ + "img/shenqing3.3b68c7b3.png";